import { render } from "./FriendSearch.vue?vue&type=template&id=1d46fcb6&scoped=true"
import script from "./FriendSearch.vue?vue&type=script&lang=js"
export * from "./FriendSearch.vue?vue&type=script&lang=js"

import "./FriendSearch.vue?vue&type=style&index=0&id=1d46fcb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d46fcb6"]])

export default __exports__